import Dictionary from "~/ts/library/Dictionary";

export const EMOJI_LIST: Dictionary<string> = {
    "grinning": "😀",
    "grin": "😁",
    "joy": "😂",
    "innocent": "😇",
    "wink": "😉",
    "blush": "😊",
    "slight_smile": "🙂",
    "upside_down": "🙃",
    "yum": "😋",
    "heart_eyes": "😍",
    "sunglasses": "😎",
    "face_with_rolling_eyes": "🙄",
    "thinking": "🤔",
    "flushed": "😳",
    "rage": "😡",
    "scream": "😱",
    "disappointed_relieved": "😥",
    "zipper_mouth": "🤐",
    "sleeping": "😴",
    "poop": "💩",
    "thumbsup": "👍",
    "see_no_evil": "🙈",
    "speak_no_evil": "🙊"
}